import tinycolor from 'tinycolor2';

export function getOverlayColor(brightness = 50) {
  const color =
    brightness < 50
      ? tinycolor('#000').setAlpha(1 - brightness / 50)
      : tinycolor('#fff').setAlpha(brightness / 50 - 1);

  return color.toRgbString();
}
